import { api } from "./api";

export async function uploadAvatar(file: File) {
  if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) throw new Error("Escolha uma imagem JPG, PNG ou WebP.");
  if (file.size > 5 * 1024 * 1024) throw new Error("A imagem precisa ter no máximo 5 MB.");
  return api.uploadAvatar(file);
}
